import { TravelBalancePage, TravelBalancePaymentStep, TravelBalanceValidationStep } from 'components';
import TravelBalanceConfirmationStep from 'components/travelBalance/TravelBalanceConfirmationStep';
import { ProtectedRoute } from 'router';

export const travelBalanceRoutes = {
  travelBalance: {
    path: '/achat-voyage/regler-le-solde',
    component: () => (
      <ProtectedRoute>
        <TravelBalancePage />
      </ProtectedRoute>
    ),
    children: {
      validation: {
        path: '/achat-voyage/regler-le-solde/validation',
        component: () => (
          <ProtectedRoute>
            <TravelBalanceValidationStep />
          </ProtectedRoute>
        )
      },
      payment: {
        path: '/achat-voyage/regler-le-solde/paiement',
        component: () => (
          <ProtectedRoute>
            <TravelBalancePaymentStep />
          </ProtectedRoute>
        )
      },
      confirmation: {
        path: '/achat-voyage/regler-le-solde/confirmation',
        component: () => (
          <ProtectedRoute>
            <TravelBalanceConfirmationStep />
          </ProtectedRoute>
        )
      }
    }
  }
};
